export default {
  GET_CHANGES_UO: 'GET_CHANGES_UO',
  GET_CHANGES_UO_SUCCESS: 'GET_CHANGES_UO_SUCCESS',
  GET_SALESMAN_CHANGE: 'GET_SALESMAN_CHANGE',
  GET_SALESMAN_CHANGE_SUCCESS: 'GET_SALESMAN_CHANGE_GET_SALESMAN_CHANGE',
  POST_UPDATE_CHAGE_UO: 'POST_UPDATE_CHAGE_UO'

}
